import { useState } from "react";
import { toast } from "react-hot-toast";
import LoadingButton from "../../components/Button/LoadingButton";
import { useUpdateCandidateMutation } from "../../graphql/generated/graphql";
import CardModal from "../Modal/CardModal";

interface CandidateActionsProps {
  candidate: any;
  jobData: any;
  candidateId: number;
  isHired: boolean;
}

const CandidateActions: React.FC<CandidateActionsProps> = ({
  candidate,
  jobData,
  candidateId,
  isHired,
}) => {
  const [updateCandidateMutation, { loading: mutationLoading }] =
    useUpdateCandidateMutation();
  const [isModalOpen, setModalOpen] = useState(false);

  const handlePhoneCall = () => {
    const candidatePhoneNumber = candidate?.phones?.[0];
    if (candidatePhoneNumber) {
      window.open(`tel:${candidatePhoneNumber}`);
    } else {
      toast.error("شماره تلفن یافت نشد!");
    }
  };

  const handleHireCandidate = async () => {
    const currentStageType =
      candidate?.jobsApplications?.nodes[0]?.pipelineStage?.type;
    const hireStageId = jobData?.job?.pipeline?.stages?.nodes.find(
      (stage: { type: string }) => stage.type === "HIRE"
    )?.id;

    const applyStageId = jobData?.job?.pipeline?.stages?.nodes.find(
      (stage: { type: string }) => stage.type === "APPLY"
    )?.id;

    const targetStageId =
      currentStageType === "HIRE" ? applyStageId : hireStageId;

    const targetStageTitle =
      currentStageType === "HIRE" ? "برکناری" : "استخدام";

    try {
      const response = await updateCandidateMutation({
        variables: {
          input: {
            id: candidateId,
            patch: {
              jobsApplications: {
                updateByCandidateIdAndJobId: [
                  {
                    candidateId,
                    jobId: jobData?.job?.id!,
                    patch: {
                      pipelineStageId: targetStageId,
                    },
                  },
                ],
              },
            },
          },
        },
      });

      if (response.data) {
        toast.success(`وضعیت کاندیدا به ${targetStageTitle} تغییر کرد`);
      }
    } catch {
      toast.error("عملیات ناموفق بود لطفا دوباره تلاش کنید!");
    }
  };

  const handleActionClick = () => {
    setModalOpen(true);
  };

  const confirmAction = () => {
    setModalOpen(false);
    handleHireCandidate();
  };

  return (
    <>
      <div className="w-full flex flex-row gap-10 py-5 px-3 items-center justify-between border-t">
        <button
          onClick={handlePhoneCall}
          className="m-auto w-1/2 text-center border border-primary p-3 rounded-md shadow font-semibold text-primary bg-white"
        >
          تماس تلفنی
        </button>
        <button
          onClick={handleActionClick}
          disabled={mutationLoading}
          className="m-auto w-1/2 text-center border border-slate-300 rounded-md shadow p-3 font-semibold bg-primary text-white"
        >
          {mutationLoading ? (
            <LoadingButton />
          ) : isHired ? (
            "برکناری"
          ) : (
            "استخدام"
          )}
        </button>
      </div>
      <CardModal open={isModalOpen} setOpen={setModalOpen} request={null}>
        <div className="text-center">
          <p>
            آیا مطمئن هستید که می‌خواهید این کاندیدا را{" "}
            {isHired ? "برکنار" : "استخدام"} کنید؟
          </p>
          <div className="mt-4 flex justify-center gap-4">
            <button
              onClick={confirmAction}
              className="px-4 py-2 rounded-md border font-semibold border-primary shadow text-white bg-primary"
            >
              بله
            </button>
            <button
              onClick={() => setModalOpen(false)}
              className="px-4 py-2 border border-gray-500 text-gray-900 rounded-md"
            >
              خیر
            </button>
          </div>
        </div>
      </CardModal>
    </>
  );
};

export default CandidateActions;
